import { call, put, takeEvery, select, fork } from "redux-saga/effects"
// Crypto Redux States
import ProductionSummaryType from "./actionTypes"

import ProductionSummaryAction from "./actions"
import ProductionSummaryAPI from "helpers/production_summary_backend_helper"

function* fetchList({ payload }) {
  console.log("masuk sini")
  yield put(
    ProductionSummaryAction.getListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(ProductionSummaryAPI.getList, payload)
    yield put(
      ProductionSummaryAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      ProductionSummaryAction.getListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* productionSummarySaga() {
  yield takeEvery(ProductionSummaryType.GET_PRODUCTION_SUMMARY_LIST, fetchList)
}

export default productionSummarySaga
